const parser = new DOMParser()

export const adSlide: HTMLElement | null = parser.parseFromString(
    `
    <swiper-slide>
        <div class="sol-content relative M3Ads M3MedRec2ads content-width-250">
            <div style="float: right; margin-bottom: 5px; display: inline-block;">
                <span class="sol-label background-lightgrey" style=" font-size: 85% !important; font-weight: 900; top: 0 !important; padding: 0 !important;">
                    <a class="sol-ads-link" href="https://www.solads.media/" target="_blank" rel="nofollow" style="font-weight: bolder;">SolAds</a>
                </span>
                <small class="sol-text-label text-white" style="display: inline !important; font-size: 85% !important;">Anzeige</small>
            </div>
            <iframe aria-label="SolAds" src="/sol?options=%7B%22adType%22%3A%22RechteckGallery%22%2C%22advertsType%22%3A%22textAd%22%2C%22imageSize%22%3A%7B%22imageWidth%22%3A250%2C%22imageHeight%22%3A250%7D%2C%22cssurl%22%3A%22https%3A%5C%2F%5C%2Fcdn.solads.media%5C%2Fcss%5C%2F_default_css%5C%2F300x250-2ads.min.css%22%2C%22advertCount%22%3A2%2C%22noLabel%22%3Afalse%7D&amp;attributes=%7B%22hideLabel%22%3Atrue%2C%22containerClass%22%3A%22M3Ads+M3MedRec2ads%22%2C%22bannerFreeType%22%3A%22nichtSehen%22%7D" scrolling="no" frameborder="0" allowtransparency="yes" class="sol-frame initialized" data-banner-free-type="nichtSehen" width="250" height="250"></iframe>
        </div>
    </swiper-slide>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null

export const adModal: HTMLElement | null = parser.parseFromString(
    `
    <div id="galleryInject">
        <div class="gallery-inject-container">
            <div style="padding-top: 20px;">
                <p class="gi-text">Anzeige</p>
            </div>
            <iframe aria-label="SolAds" src="https://syndication.realsrv.com/ads-iframe-display.php?idzone=3767095&amp;size=300x250" width="300" height="250" scrolling="no" marginwidth="0" marginheight="0" frameborder="0"></iframe>
            <div style="padding-top: 10px;">
                <a href="#" onclick="$('#galleryInject').remove(); return false;" class="button-sm ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-left ui-btn-up-b">
                    <span class="btn btn-lg btn-block btn-ladies-primary m-5-b ui-btn-inner ui-btn-corner-all">
                        <span class="ui-btn-text">Werbung schließen</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null
